import React, { Component } from 'react';
import './Home.css';

import ls from 'localstorage-slim';

import { GraphicsIllustrate } from './GraphicsIllustrate/GraphicsIllustrate';
import { Instructions } from './Instructions/Instructions';
import { Introduction } from './Introduction/Introduction';
import { FAQ } from './FAQ/FAQ';
import { Login } from './Login/Login';
import clickLogo from './.image/组 63@3x.png';
import gifPicture from './.image/gif_動畫_0913.gif';
import backgroundPic from './.image/backgroundPic.png';
import ApiBase from "../../modules/WebApiModules/ApiBase";
import loginPic from './.image/login.png';

export class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            topbar: 2,
            viewer: 57,
            allViewer: 684,
            isLogined: false,
            username: "",
            currentAuthority: "",
        };

        this.otherSites = [
            { title: "南投縣政府", url: 'https://www.nantou.gov.tw/' },
            { title: "南投縣政府開放資料平台", url: 'https://data.nantou.gov.tw/' },
            { title: "南投縣施政統計應用圖台", url: "https://smap.nantou.gov.tw/map/" },
        ];
    }

    componentDidMount() {
        this.getViewer();

        this.login();
    }

    async getViewer() {
        let getViewerUrl = ApiBase.MakeUrl("WebService/ViewerNumber/getViewersofDay");

        try {
            const response = await fetch(getViewerUrl, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                })
            });
            const json = await response.json();
            if (json.success) {
                this.setState({ viewer: json.viewer });

                let getAllViewer = ApiBase.MakeUrl("WebService/ViewerNumber/getAllViewers");
                const allViewerRes = await fetch(getAllViewer, {
                    method: "POST",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    })
                });
                const allViewerJson = await allViewerRes.json();
                if (allViewerJson.success) {
                    this.setState({ allViewer: allViewerJson.viewer });
                }
                else {
                    console.log("get all viewer false");
                }
            }
            else {
                console.log("get viewer false");
            }

        } catch (error) {
            console.log("error:", error);
        }
    }

    gotoMap() {
        //window.location = "/map";
        this.props.changePage(2);
    }

    gotoGovernment() {
        console.log("(如何到達縣府)");
    }
    privacyPolicy() {
        console.log("隱私權政策");
    }
    openDataDeclare() {
        console.log("政府網站資料開放宣告");
    }

    topbarVisiblity() {
        switch (this.state.topbar) {
            case 2: return (<Introduction />);
            case 3: return (<GraphicsIllustrate />);
            case 4: return (<FAQ />);
            case 5: return (<Instructions />);
            case 6: return (<Login login={this.login.bind(this)} />);
            default: return;
        }
    }

    dropmenu() {
        return (
            <ul className="topbar-dropDownMenu" >
                {this.otherSites.map((site) => (
                    <li key={site.title}>
                        <a href={site.url} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
                            {site.title}
                        </a>
                    </li>
                ))}
            </ul>
        );
    }

    gotoBackend_OnClick() {
        const link = document.createElement("a");
        link.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}backend/`;
        link.target = "_blank";
        link.click();
        link.remove();
    }

    logout() {
        let cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            let eqPos = cookie.indexOf("=");
            let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
        ls.clear();

        this.setState({ isLogined: false });
    }

    login() {
        let lsInfo = ls.get("userInfo", { decrypt: true });
        if (lsInfo) {
            this.setState({ isLogined: true, topbar: 2, username: lsInfo.name, currentAuthority: lsInfo.currentAuthority });
        }
    }

    render() {
        return (
            <div>
                <div style={{ height: '100vh', display: 'flex', flexFlow: 'column' }}>
                    {/*<div className='container'>*/}
                    <div className='header'>
                        <div className='header-left'>
                            {/*<img className='header-left-background' src={cloud} alt="首頁_雲"></img>*/}
                            <img className='header-left-background' src={backgroundPic} alt="首頁_山"></img>
                            <div className='header-left-click' onClick={() => this.gotoMap()}>
                                <img src={clickLogo} style={{ height: '100%' }} alt="首頁_標誌"></img>
                            </div>
                        </div>
                        <div className='header-right'>
                            <img className='header-right-gif' src={gifPicture} alt="首頁_動畫"></img>
                        </div>
                    </div>
                    <div className='topbar'>
                        {/* <div className={this.state.topbar === 1 ? 'topbar-tab-choose' : 'topbar-tab'} onClick={() => this.setState({ topbar: 1 })}>最新消息</div> */}
                        <div className={this.state.topbar === 2 ? 'topbar-tab-choose' : 'topbar-tab'} onClick={() => this.setState({ topbar: 2 })}>簡介</div>
                        <div className={this.state.topbar === 3 ? 'topbar-tab-choose' : 'topbar-tab'} onClick={() => this.setState({ topbar: 3 })}>圖資使用說明</div>
                        <div className={this.state.topbar === 4 ? 'topbar-tab-choose' : 'topbar-tab'} onClick={() => this.setState({ topbar: 4 })}>常見問答集</div>
                        <div className={this.state.topbar === 5 ? 'topbar-tab-choose' : 'topbar-tab'} onClick={() => this.setState({ topbar: 5 })}>操作說明</div>
                        <div className='topbar-tab topbar-drop-down'>好站連結
                            {this.dropmenu()}
                        </div>
                        {!this.state.isLogined ? <img src={loginPic} className="topbar-login" onClick={() => this.setState({ topbar: 6 })} alt="login"/> :
                            <>
                                <div className='topbar-tab' onClick={() => { this.logout() }}>登出</div>
                                {this.state.currentAuthority === "admin" ? <div className='topbar-tab' onClick={() => { this.gotoBackend_OnClick(); }}>後台</div> : null}
                                <div className='topbar-username'>歡迎，{this.state.username}</div>
                            </>
                        }
                    </div>
                    <div className='topbar-bottom'></div>
                    <div className='middle-space'>
                        <div className='middle-space-inner'>
                            {
                                this.topbarVisiblity()
                            }
                        </div>
                    </div>
                    <div className='footer'>
                        <div className='footer-left'>
                            <div className='footer-left-font'>
                                <div className='footer-info'>
                                    <div className='footer-info-border'>地址:54001 南投市中興路660號
                                        <span className='footer-info-botton' onClick={() => this.gotoGovernment()}>(如何到達縣府)</span>
                                    </div>
                                    <div className='footer-info-border'>電話:(049)2222106-9</div>

                                </div>

                            </div>
                        </div>
                        <div className='footer-center'>
                            <div className='footer-left-font'>
                                <div className='footer-info'>
                                    <div className='footer-info-border'>上班時間:上午08:00-12:00;下午13:30-17:30;</div>
                                    <div className='footer-info-border'>彈性上班時間:07:30-08:30;17:00-18:00(週六、日及假日休息)</div>
                                </div>

                            </div>
                        </div>
                        <div className='footer-right'>
                            <div className='footer-visit'>本日到訪人數:{this.state.viewer}{/* | 本月到訪人數:{157} */}| 到訪人次累積總人次:{this.state.allViewer}</div>
                            <div>
                                <span className='footer-info-botton' onClick={() => this.privacyPolicy()} >隱私權政策</span><span> | </span>
                                <span className='footer-info-botton' onClick={() => this.openDataDeclare()} >政府網站資料開放宣告</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
